import "./App.css";
import Header from "./components/Header";
import Landing from "./components/Landing";
import About from "./components/About";
import MobileMenu from "./components/MobileMenu";
import DesktopMenu from "./components/DesktopMenu";
import SectionBreak from "./components/SectionBreak";
import MobileReservations from "./components/MobileReservations";
import DesktopReservations from "./components/DesktopReservations";
import MobileContactInfo from "./components/MobileContactInfo";
import DesktopContactInfo from "./components/DesktopContactInfo";

function App() {
    return (
        <div className="App">
            <header className="header-container">
                <div className="left-box">
                    <Landing />
                </div>
                <div className="right-box">
                    <Header />
                    <Landing />
                    <About />
                </div>
            </header>

            <section className="menu-container">
                <DesktopMenu />
                <MobileMenu />
            </section>

            <section className="section-break-container">
                <SectionBreak />
            </section>

            <section className="reservations-container">
                <MobileReservations />
            </section>

            <footer className="contact-info-container">
                <MobileContactInfo />
            </footer>

            <footer className="footer-container">
                <div className="left-box">
                    <SectionBreak />
                </div>
                <div className="right-box">
                    <DesktopReservations />
                    <DesktopContactInfo />
                </div>
            </footer>
        </div>
    );
}

export default App;
